import axios from "axios";
import { Auth } from "aws-amplify";

const apiClient = axios.create();

let refreshPromise = null;

const getAccessToken = async () => {
  const session = await Auth.currentSession();
  return session.getAccessToken().getJwtToken();
};

const refreshAccessToken = async () => {
  if (!refreshPromise) {
    refreshPromise = Auth.currentSession()
      .then((session) => {
        return session.getAccessToken().getJwtToken();
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};

const signOutUser = async () => {
  try {
    await Auth.signOut();
  } catch (error) {
    console.error("Error signing out:", error);
  } finally {
    localStorage.removeItem("userInfo");
    window.location.href = "/login";
  }
};

apiClient.interceptors.request.use(async (config) => {
  if (config.requiresAuth) {
    try {
      const accessToken = await getAccessToken();

      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${accessToken}`;
    } catch (error) {
      console.error("Error retrieving access token:", error);
    }
  }

  if (!config.baseURL) {
    config.baseURL = process.env.REACT_APP_API_URL;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status !== 401 ||
      !originalRequest ||
      originalRequest._retry
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const newToken = await refreshAccessToken();

      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer ${newToken}`;

      return apiClient(originalRequest);
    } catch (refreshError) {
      await signOutUser();
      return Promise.reject(refreshError);
    }
  },
);

export default apiClient;
